import { get } from './Global';

export const getRepairMethods = () => {
    return get('/fapi/way/list')
}

export const getAccountStatus = () => {
    return get('/fapi/account/status');
}

//check账号能否走指定评分项
export const checkSafePhoneGrade = () => {
    return get("/fapi/grade/check", { item: "PHONE_REPAIR" });
}

// 资料检查
export const checkFillDataValid = (params: Record<string, unknown>) => {
    return get("/fapi/data/check", params);
}

export const checkContactEmailRequired = () => {
    return get("/fapi/globalConfig");
}